module.exports = __webpack_public_path__ + "img/func.c59498b3.png";